export default "__VITE_ASSET__450f88b7__"